import {
  AI_CHAT_ADD_HISTORY,
  AI_CHAT_CONVERSATIONS_ERROR,
  AI_CHAT_CONVERSATIONS_LOADING,
  AI_CHAT_ERROR,
  AI_CHAT_LOADING,
  AI_CHAT_SET_CONVERSATION,
  AI_CHAT_SET_CONVERSATIONS,
  AI_CHAT_SET_CONVERSATION_MESSAGES,
  AI_CHAT_SET_REPLY,
  AI_CHAT_SUCCESS
} from '../../../types/aiChatTypes';

export const AI_CHAT_ACTIONS = {
  AI_CHAT_LOADING,
  AI_CHAT_SUCCESS,
  AI_CHAT_ERROR,
  AI_CHAT_SET_REPLY,
  AI_CHAT_SET_CONVERSATION,
  AI_CHAT_ADD_HISTORY,
  AI_CHAT_CONVERSATIONS_LOADING,
  AI_CHAT_SET_CONVERSATIONS,
  AI_CHAT_CONVERSATIONS_ERROR,
  AI_CHAT_SET_CONVERSATION_MESSAGES
};
